import React from "react";
import PageLayout from "./PageLayout";
import PageHero from "./PageHero";
import ImageCarousel from "./ImageCarousel";
import VideoEmbed from "./VideoEmbed";
import FadeIn from "./FadeIn";

/** Carousel + optional video gallery layout for arts/WKW event pages */
const EngagementCarouselPage = ({
  title,
  paragraphs = [],
  images = [],
  videos = [],
  altPrefix,
}) => (
  <PageLayout>
    <PageHero title={title} light />
    <section className="ku-section bg-white">
      <div className="ku-container max-w-5xl space-y-10">
        {videos.map((url, i) => (
          <FadeIn key={url} delay={i * 0.05}>
            <VideoEmbed src={url} title={`${title} video ${i + 1}`} />
          </FadeIn>
        ))}
        {paragraphs.length > 0 && (
          <FadeIn delay={videos.length * 0.05}>
            <div className="ku-prose max-w-3xl">
              {paragraphs.map((text, i) => (
                <p key={i}>{text}</p>
              ))}
            </div>
          </FadeIn>
        )}
        {images.length > 0 && (
          <FadeIn delay={0.1}>
            <ImageCarousel images={images} altPrefix={altPrefix || title} />
          </FadeIn>
        )}
      </div>
    </section>
  </PageLayout>
);

export default EngagementCarouselPage;
